import useDialogStore from '@globals/dialog/useDialogStore'
import { trackLogRocketEvent } from '@globals/logRocket'
import { useEffect } from 'react'
import { MOBILE_SEND_RECOGNITION_DRAWER_KEY } from './MobileRecognition/constants'
import { MOBILE_RECOGNITION_DRAWER_KEY } from './MobileRecognition/useMobileRecognitionDrawer'
import { RECOGNITION_MODAL_KEY } from './RecognitionModal/useRecognitionModal'

export const RECOGNITION_MODAL_OPENED_EVENT = 'RecognitionModalOpened'

/**
 * Every surface of the recognition composer: the desktop dialog (rendered as a
 * bottom drawer at the tablet breakpoint), the mobile step drawer, and the
 * mobile full-screen send screen.
 */
const RECOGNITION_COMPOSER_DIALOG_KEYS = [
  RECOGNITION_MODAL_KEY,
  MOBILE_RECOGNITION_DRAWER_KEY,
  MOBILE_SEND_RECOGNITION_DRAWER_KEY,
]

type DialogsState = ReturnType<typeof useDialogStore.getState>['dialogs']

const isRecognitionComposerOpen = (dialogs: DialogsState): boolean =>
  RECOGNITION_COMPOSER_DIALOG_KEYS.some(key => dialogs[key]?.isOpen)

/**
 * Fires the LogRocket `RecognitionModalOpened` event each time the recognition
 * composer goes from fully closed to open, however it was opened.
 *
 * The mobile flow hands off between the step drawer and the send screen (it
 * opens the next one before closing the current one), so the composer is
 * treated as open while any of its surfaces is open — moving between steps is
 * not counted as a new open.
 */
const useTrackRecognitionComposerOpen = () => {
  useEffect(
    () =>
      useDialogStore.subscribe((state, prevState) => {
        if (
          isRecognitionComposerOpen(state.dialogs) &&
          !isRecognitionComposerOpen(prevState.dialogs)
        ) {
          trackLogRocketEvent(RECOGNITION_MODAL_OPENED_EVENT)
        }
      }),
    [],
  )
}

export default useTrackRecognitionComposerOpen
